import { useTheme } from "@rentiohq/web-shared-next/dist/themes";
import { EFontWeights } from "@rentiohq/web-shared-next/dist/themes/types";

export const IbanAccountSelectStyles = () => {
  const theme = useTheme();
  return {
    content: {
      heading: {
        color: theme.palette.grey[900],
      },
      actionBtn: {
        width: "240px",
      },
      iban: {
        color: theme.palette.grey[600],
      },
      accountName: {
        fontWeight: EFontWeights.Regular,
      },
    },
  };
};
